export default "__VITE_ASSET__BEDWk0r$__"